import React from 'react';
import { FaEnvelope, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

const ContactSidebar = () => {
  return (
    <div className="contact-sidebar">
      <a href="mailto:info@cloudkodeform.com" className="sidebar-icon email" target="_blank" rel="noopener noreferrer">
        <FaEnvelope />
      </a>
      <a href="tel:+919650792424" className="sidebar-icon call">
        <FaPhoneAlt />
      </a>
      <a
        href="https://wa.me/919650792424"
        className="sidebar-icon whatsapp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default ContactSidebar;
